<mat-drawer-container [hasBackdrop]="false">
    <mat-drawer #drawer [mode]="'side'" [ngClass]="{'blast-device-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <div class="section start flex-column middle justify">
            <div>
                <button mat-flat-button color="white" (click)="showDrawingManager('Point')" class="mat-pickers button" [disabled]="disableAddDevice">
                    Add Device Location
                </button>
            </div>

            <div class="full-height full-width">
                <mat-selection-list #vehicles (selectionChange)="onVehicleSelectionChange($event)">
                    <mat-list-option *ngFor="let vehicleProp of vehicleProperties"
                        [value]="vehicleProp[0]" [selected]="vehicleProp[2]">
                        <button class="vehicle-color-indicator" [style.background]="vehicleProp[1]"></button>
                        {{ vehicleProp[0].name }}
                    </mat-list-option>
                </mat-selection-list>
                <!-- do not need to give selection option for now -->
                <!-- <div class="flex-row center">
                    <button mat-flat-button color="primary"
                        (click)="saveSelectedOptions(vehicles.selectedOptions.selected)"
                        class="button mat-pickers full-width m">
                        Get
                    </button>
                </div> -->
            </div>
        </div>
    </mat-drawer>
    <mat-drawer #geofenceDrawer [mode]="'side'" [ngClass]="{'geofence-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <div class="section start flex-column middle justify geofence-content">
            <div>
                Geofence Record
            </div>
        </div>
        <div class="container">
            <ng-container *ngIf="geofenceRecords$ | async as geofenceRecords">
                <div *ngFor="let record of geofenceRecords" class="geofence-data-content container"
                    [matBadge]="record.type === 'Geofence Entry' ? 'Entry' : 'Exit'" matBadgePosition="before"
                    matBadgeSize="large" 
                    [ngClass]="{'entry-badge': record.type === 'Geofence Entry', 'exit-badge': record.type === 'Geofence Exit'}">
                    <div class="centered-content muckpile-time-content">
                            <mat-icon mat-icon-button svgIcon="muckpile-tag" class="muckpile-time-icon"></mat-icon>
                        <div class="muckpile-vehicle-name">{{ record.muckpileName }} / {{ record.vehicleName }}</div>
                    </div>
                    <div class="centered-content muckpile-time-content">
                        <mat-icon class="muckpile-time-icon centered-content">access_time</mat-icon>
                        <div>{{ record.time| date: dateTimeFormat }}</div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="(geofenceRecords$ | async) === undefined" class="container centered-content full-width half-height">
            <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
          </div>
          <div *ngIf="(geofenceRecords$ | async)?.length === 0" class="container centered-content">
            <div class="container centered-content">
              <div>
                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
              </div>
              <div>No Data Found</div>
            </div>
          </div>
    </mat-drawer>

    <mat-drawer-content class="section map-container"
        [ngClass]="{'map-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <div class="full-height full-width">
            <div *ngIf="(device$|async)==undefined" class="container-80 flex-column center middle full-width full-height">
                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
            </div>
            <div #map class="full-height full-width"></div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
